import React, { useRef, useEffect, useCallback, FC } from 'react'
import { AmazingTabs } from 'cat-design'
import styles from './index.module.less'

const TAB_WIDTH = 84
const px2px = (px: number) => {
  const windowWidth = typeof window === 'undefined' ? 375 : window.innerWidth
  return (px / 375) * windowWidth
}

interface IGetParamsProps extends IHeader {
  tabWidth: number
}
const getParams = ({ activeTab, setActiveTab, tabNames, tabWidth }: IGetParamsProps) => {
  return {
    list: tabNames,
    key: tabNames?.map((_, index) => index).join(','),
    options: {
      align: 'center',
      slideDuration: 300,
      sticky: false,
    },
    currentPage: activeTab,
    // eslint-disable-next-line react/display-name
    renderTab: (item) => <div style={{ width: `${px2px(tabWidth)}px` }}>{item}</div>,
    onTabChange: (index) => {
      setActiveTab(index)
    },
  }
}

interface IHeader {
  activeTab: number
  setActiveTab: (T: number) => void
  tabNames: string[]
}
const Header: FC<IHeader> = ({ activeTab, setActiveTab, tabNames }) => {
  const detailTabRef = useRef(null)

  useEffect(() => {
    detailTabRef.current?.scrollTo?.({
      left: px2px(TAB_WIDTH) * (activeTab - 1),
      behavior: 'smooth',
    })
  }, [activeTab])

  const params = getParams({
    activeTab,
    setActiveTab,
    tabNames,
    tabWidth: TAB_WIDTH,
  })

  return (
    <div className={styles.detailTab} ref={detailTabRef}>
      <AmazingTabs {...params} />
    </div>
  )
}

export default Header
